<template>
  <el-container>
    <el-header style="margin-top: 20px;">
      Crear menu por perfil de usuario
    </el-header>
    <el-container style="margin-top: 20px;">
      <el-aside style="overflow-y: auto; height: 500px;">
        <build :items="menu" :is-save-menu="true" :orientation="'vertical'">
        </build>
      </el-aside>
      <el-main>
        <build :items="menu" :orientation="'horizontal'"></build>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
  import { getMenu } from '@/api/menu_build'
  import Build from '@/components/Menu/Build'

  export default {
    name: 'MenuProfile',

    components: {
      Build
    },

    data() {
      return {
        menu: [],
        selectedItems: []
      }
    },

    created() {
      getMenu().then(response => {
        this.menu = response.data
      })
    }
  }
</script>
